const DOM_DELTA_LINE = 1
const DOM_DELTA_PAGE = 2
const PIXELS_PER_LINE = 16
const MAX_ABS_WHEEL_DELTA = 120

export const MAIN_WHEEL_ZOOM_SENSITIVITY = 0.008
export const PIXEL_WHEEL_ZOOM_SENSITIVITY = 0.008

export interface WheelZoomInput {
  deltaY: number
  deltaMode: number
}

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max)

export const normalizeWheelDelta = (
  event: WheelZoomInput,
  pageHeight = typeof window !== 'undefined' ? window.innerHeight : 800,
) => {
  let delta = event.deltaY

  if (event.deltaMode === DOM_DELTA_LINE) {
    delta *= PIXELS_PER_LINE
  } else if (event.deltaMode === DOM_DELTA_PAGE) {
    delta *= pageHeight
  }

  return clamp(delta, -MAX_ABS_WHEEL_DELTA, MAX_ABS_WHEEL_DELTA)
}

export const getWheelZoomMultiplier = (
  event: WheelZoomInput,
  sensitivity: number,
  pageHeight?: number,
) => {
  const normalizedDelta = normalizeWheelDelta(event, pageHeight)
  return Math.exp(-normalizedDelta * sensitivity)
}
